import {
    IEventLight,
    ISubscribeEvent,
    IUnSubscribeEvent,
    IActirisError,
    IEventDate,
    IHashtag,
    IEventParameters,
    ICategoryEvent,
} from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const EventService = {
    async getAll(eventParameters: IEventParameters): Promise<IEventLight[]> {
        const response = await fetch('/Api/Event/GetAll', {
            method: 'POST',
            body: JSON.stringify(eventParameters),
            headers,
        });
        return await response.json();
    },
    async getPromoted(
        broadcastChannelExternalIds: number,
        max: number
    ): Promise<IEventLight[]> {
        const response = await fetch(
            '/Api/Event/GetPromoted?broadcastChannel=' +
                broadcastChannelExternalIds +
                '&max=' +
                max,
            {
                method: 'GET',
                headers,
            }
        );
        return await response.json();
    },
    async subscribeEvent(subscribe: ISubscribeEvent): Promise<IActirisError[]> {
        const response = await fetch('/Api/Event/SubscribeEventById', {
            method: 'POST',
            body: JSON.stringify(subscribe),
            headers,
        });
        return await response.json();
    },
    async unSubscribeEvent(
        unSubscribe: IUnSubscribeEvent
    ): Promise<IActirisError> {
        const response = await fetch('/Api/Event/UnSubscribeEventById', {
            method: 'POST',
            body: JSON.stringify(unSubscribe),
            headers,
        });
        return await response.json();
    },
    async getAllInfoServiceAnimation(
        broadcastChannel: number,
        language: string | null = null
    ): Promise<IEventDate[]> {
        const url = new URL(
            '/Api/Event/GetAllInfoServiceAnimation',
            window.location.origin
        );
        url.searchParams.append(
            'broadcastChannelExternalId',
            broadcastChannel.toString()
        );

        if (language) {
            url.searchParams.append('language', language);
        }

        const response = await fetch(url.toString(), {
            method: 'GET',
            headers,
        });
        return await response.json();
    },

    async GetHashtag(): Promise<IHashtag[]> {
        const response = await fetch('/Api/Event/GetHashtag', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },

    async GetCategories(): Promise<ICategoryEvent[]> {
        const response = await fetch('/Api/Event/GetCategories', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },
};
